import { __makeTemplateObject } from './../../../external/tslib/tslib.es6.js';
import styled, { css } from 'styled-components';

var SuffixIcon = styled.button(function (_a) {
    var input = _a.theme.olist.components.input;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: none;\n    border: none;\n    color: ", ";\n    display: flex;\n    padding: 0;\n    cursor: pointer;\n  "], ["\n    background: none;\n    border: none;\n    color: ", ";\n    display: flex;\n    padding: 0;\n    cursor: pointer;\n  "])), input.suprefix.color);
});
var templateObject_1;

export { SuffixIcon };
